import _ from "lodash";

export const queryHandler = (searchParams) => {
	let tempSearch = _.cloneDeep(searchParams);
	let tempQuery = {};
	let tempAnd = []

	tempSearch.map((searchChild) => {
		if (searchChild.param?.[0]) {
			if (searchChild.type === 'checkbox'){
        tempQuery = {
					... tempQuery,
					$or: [
						... searchChild.param.map( paramChild => ({
							[searchChild.value]: paramChild
						}))
					]
				}
			} 

			else if (searchChild.type === 'select' ){
				tempQuery = {
					... tempQuery,
					[searchChild.value]: searchChild.param === 'true' 
						? true 
						: searchChild.param === 'false' 
							? false 
							: searchChild.isNumeric 
								? +searchChild.param
								: searchChild.param
				}
			}


      else if (searchChild.extra){ 
        tempAnd.push({
          ... searchChild.extra,
          [searchChild.value]: { $like: `%${ searchChild.param }%` }
        })
      }

			else {
				tempQuery = {
					... tempQuery,
					[searchChild.value]: searchChild.exact ? searchChild.param : { $like: `%${ searchChild.param }%` }
				}
			}
		}
	});

	if (tempAnd?.[0]){{
    tempQuery = {
      ... tempQuery,
      "$and": tempAnd
    }
  }}

	return tempQuery;
};
